import React from 'react';

import i18next from 'i18next';

import { DEFAULT_ALGORITHM_TYPES } from 'common/constants';

import initialValues from '../initialValues';

import { createParametersBuilder } from './builders/buildParameters';
import { createPayloadBuilder } from './builders/buildPayload';
import { createPrepareUpdateValuesBuilder } from './builders/buildPrepareUpdateValues';
import { createTabsBuilder } from './builders/buildTabs';
import { createValidationSchema } from './builders/buildValidation';

/**
 * Factory para crear configuraciones de partners reutilizables
 * @param {Object} config - Configuración del partner
 * @returns {Object} Configuración completa del partner
 */

export const createPartnerConfig = (config) => {
    const {
        ParametersComponent,
        algorithms = DEFAULT_ALGORITHM_TYPES,
        buildParametersConfig,
        buildPayloadConfig,
        buildPrepareValuesConfig,
        customAlgorithms = [],
        name,
        tabsConfig,
        validationConfig,
    } = config;

    // Crear builders con las extensiones del partner
    const buildParameters = createParametersBuilder(buildParametersConfig);
    const buildPayload = createPayloadBuilder({
        ...buildPayloadConfig,
        buildParameters,
    });
    const getPrepareUpdateValuesFunc = (values) =>
        createPrepareUpdateValuesBuilder(buildPrepareValuesConfig)(
            values,
            getInitialValues(),
        );
    const validate =
        validationConfig.schema || createValidationSchema(validationConfig);

    /**
     * Obtiene las opciones de algoritmos disponibles
     */

    /**
     * Obtiene los valores iniciales
     */
    const getInitialValues = () => ({ ...initialValues });

    const getAlgorithmOptions = () => {
        const custom = customAlgorithms.map((item) => ({
            label: i18next.t(item.label),
            value: item.value,
        }));

        return [...algorithms, ...custom];
    };

    // Wrapper del componente Parameters para inyectar algorithmOptions

    const ParametersComponentWrapper = (props) => (
        <ParametersComponent
            {...props}
            algorithmOptions={getAlgorithmOptions()}
        />
    );

    const getTabs = createTabsBuilder(ParametersComponentWrapper, tabsConfig);

    return {
        buildPayload,
        getAlgorithmOptions,
        getInitialValues,
        getPrepareUpdateValues: getPrepareUpdateValuesFunc,
        getTabs,
        name,
        validate,
    };
};
